export const SEND_FORM = 'SEND_FORM';
export const SET_FIELD_MODEL_CLASS = 'SET_FIELD_MODEL_CLASS';
export const SET_FIELD_MODEL_ID = 'SET_FIELD_MODEL_ID';
export const SET_FIELD_TYPES = 'SET_FIELD_TYPES';
export const SET_FIELD_CONTENT = 'SET_FIELD_CONTENT';

export const SET_RESULT_OBJECT = 'SET_RESULT_OBJECT';
export const INIT_STATE = 'INIT_STATE';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/complaints/addComplaintForm/actionsTypes.js